// extracted by mini-css-extract-plugin
export default {"taskComment":"index_taskComment__lvw+-"};